module.exports = __webpack_public_path__ + "static/media/bmw_media_down_hov_b 1.63242214.svg";